import { render } from "./ViewTabs.vue?vue&type=template&id=0637396e&scoped=true"
import script from "./ViewTabs.vue?vue&type=script&lang=js"
export * from "./ViewTabs.vue?vue&type=script&lang=js"

import "./ViewTabs.vue?vue&type=style&index=0&id=0637396e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0637396e"]])

export default __exports__